import styled from 'styled-components';

export const Orderedlist = styled.ol`
  list-style: none;
  display: flex;
  align-items: center;
  font-size: 1.5em;
  font-weight: bold;
  & a:hover {
    color: #555;
  }
`;

export const BreadcrumbList = styled.li`
  color: #333;
  margin: auto 6px;
  user-select: none;
`;

export const ItemList = styled.li`
  & a:active {
    color: #d22;
  }
`;
